import { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FAQ from "../../components/faq/FAQ";
import StateButton from "../../components/state-button/StateButton";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import playButton from "../../assets/images/Play-Button.png";
import { IoIosArrowRoundForward } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import Image from "react-bootstrap/Image";
import Skeleton from "@mui/material/Skeleton";

import "./Home.scss";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import Carousel from "react-bootstrap/Carousel";

import {
  getDigitalMailCountryList,
  getPhoneNumberCountryList,
  getAllBanners,
  getCounterInBanner,
  getAllTestimonials,
} from "../../api/apiRequest";
import { useLangContext } from "../../context/languageContext";
import VideoPlayer from "../video-modal/VideoPlayer";

import { Tag } from "../../utils/GTMPageTag";
import { Helmet } from "react-helmet";

import { useTranslation } from "react-i18next";

const Home = () => {
  Tag("Home")
  
  const { t, i18n } = useTranslation(["common","home"]);

  const { hostLanguage } = useLangContext();

  const [mailCountries, setMailCountries] = useState([]);
  const [phoneCountries, setPhoneCountries] = useState([]);
  const [bannersDetails, setBannersDetails] = useState([]);
  const [counterDetails, setcounterDetails] = useState({});
  const [testimonialDetails, setTestimonialDetails] = useState([]);

  const [showVideoModal, setShowVideoModal] = useState(false);
  const handleVideoModalClose = () => setShowVideoModal(false);
  const [videoUrl, setVideoUrl] = useState();
  const [bannerVideolink, setBannerVideolink] = useState();

  const fetchMailProductCountries = async () => {
  try {
    let apiRes = await getDigitalMailCountryList();
    let responseData = await apiRes.json();
    
    if (responseData.res) {
      // Extract and filter objects
      const dataArr = Object.values(responseData.data)
        .filter((obj) => typeof obj === "object")
        // Sort by country name (from nested country_name property)
        .sort((a, b) => {
          const nameA = a[0]?.country_name?.toLowerCase() || "";
          const nameB = b[0]?.country_name?.toLowerCase() || "";
          return nameA.localeCompare(nameB);
        });

      setMailCountries(dataArr);
    } else {
      NotificationManager.error(responseData.msg, "", 2000);
    }
  } catch (error) {
    console.error(error);
  }
};


  // get all phone based countries
  const fetchPhoneProductCountries = async () => {
    try {
      let apiRes = await getPhoneNumberCountryList();
      let responseData = await apiRes.json();
      if (responseData.res) {
        setPhoneCountries(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // get all banner information
  const allBanners = useCallback( async () => {
    try {
      let apiRes = await getAllBanners(hostLanguage);
      let responseData = await apiRes.json();
      if (responseData.res) {
        setBannersDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  },[i18n]);

  // get banner image link
  const getBannerImgLink = (img_link) => {
    try {
      let base_url = "https://cleverdomizil.de";
      let url = base_url + img_link?.split("httpdocs")[1];
      return url;
    } catch (error) {
      console.error(error);
    }
  };
  

  // get banner counter information
  const getBannerCounterInfo = async () => {
    try {
      let apiRes = await getCounterInBanner();
      let responseData = await apiRes.json();
      if (responseData.res) {
        setcounterDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // get all testimonials
  const getAllTestimonialsInfo = useCallback( async () => {
    try {
      let apiRes = await getAllTestimonials(hostLanguage);
      let responseData = await apiRes.json();
      if (responseData.res) {
        setTestimonialDetails(responseData.data);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  },[i18n]);

  const videoModalFunc = (video_type_url, video_url) => {
    setVideoUrl(video_type_url);
    setBannerVideolink(video_url);
    setShowVideoModal(true);
  };

  useEffect(() => {
    fetchMailProductCountries();
    fetchPhoneProductCountries();
    allBanners();
    getBannerCounterInfo();
    getAllTestimonialsInfo();
  }, [hostLanguage, allBanners, getAllTestimonialsInfo]);

  //console.log(i18n)
  if (!i18n.isInitialized) return null;
  

  return (
    <>
      <Helmet>
        <title>{t("home:meta.title")}</title>
        <meta name="language" content={hostLanguage} />
        <meta name="description" content={t("home:meta.title")} />
        <meta name="keywords" content={t("home:meta.keywords")} />
        <script type="application/ld+json">{JSON.stringify(t("home:meta.schema", { returnObjects: true }))}</script>
      </Helmet>
      <div id="Home" className="WebBody">
        <div className="BannerScetion">
          <Carousel data-bs-theme="dark">
            {bannersDetails?.map((item, index) => {
              return (
                <Carousel.Item key={index}>
                  {item?.video_url === null ||
                  item?.video_url === "" ||
                  item?.video_url === undefined ? (
                    <></>
                  ) : (
                    <Image
                      src={playButton}
                      style={{ cursor: "pointer" }}
                      className="player-icon"
                      alt="Player icon"
                      onClick={() =>
                        videoModalFunc("banner_video_url", item?.video_url)
                      }
                    />
                  )}
                  <img
                    className="d-block w-100"
                    src={getBannerImgLink(item?.image)}
                    alt="First slide"
                  />
                  <img 
                    style={{
                      top: "10px",
                      left: "10px",
                      position: "absolute",
                      display: "block",
                      width: "40px",
                      height: "40px"
                    }}
                    src={"/AI.png"}
                  />
                  <Carousel.Caption>
                    <div
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    />
                  </Carousel.Caption>
                </Carousel.Item>
              );
            })}
          </Carousel>
          <div className="BannerScetionBottom">
            <Container className="">
              <Row>
                <Col sm={12} md={3}>
                  <div className="BannerScetionBottomBox ">
                    <h1>{t("home:banner.text_1")}</h1>
                    <p>
                      {counterDetails?.company_foundation}+{" "}
                      {t("countries")}
                    </p>
                  </div>
                </Col>
                <Col sm={12} md={3}>
                  <div className="BannerScetionBottomBox ">
                    <h1>{t("home:banner.text_2")}</h1>
                    <p>
                      {counterDetails?.customer_foundation}+{" "}
                      {t("countries")}
                    </p>
                  </div>
                </Col>
                <Col sm={12} md={3}>
                  <div className="BannerScetionBottomBox ">
                    <h1>{t("home:banner.text_3")}</h1>
                    <p>
                      {counterDetails?.number_world_wide}+{" "}
                      {t("countries")}
                    </p>
                  </div>
                </Col>
                <Col sm={12} md={3}>
                  <div className="BannerScetionBottomBox last-child">
                    <h1>{t("home:banner.text_4")}</h1>
                    <p>
                      {counterDetails?.register_agents}+{" "}
                      {t("countries")}
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <div className="InfoScetion">
          <Container className="InfoScetionContainer">
            <Row className="align-items-center">
              <Col sm={6}>
                <div className="InfoScetionLft">
                  <h3>{t("home:info.heading")}</h3>
                  <p>{t("home:info.description")}</p>
                  <Link to="geschaeftsadresse">{t("home:info.link")}</Link>
                </div>
              </Col>
              <Col sm={6}>
                <div className="InfoScetionRgt">
                  <Image
                    src={t("home:info.image_url")}
                    alt={t("home:info.image_alt")}
                    fluid
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="ServicesScetion">
          <Container className="InfoScetionContainer">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t("home:services.heading")}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <div className="ServicesBox">
                  <div className="ServicesBoxLft">
                    <Image
                      src={t("home:services.1.image_url")}
                      alt={t("home:services.1.image_alt")}
                    />
                  </div>
                  <div className="ServicesBoxRgt">
                    <h1>{t("home:services.1.heading")}</h1>
                    <p>{t("home:services.1.description")}</p>
                    <Link to="/geschaeftsadresse">
                      {t("moreInformation")}
                      <IoIosArrowRoundForward size={27} />
                    </Link>
                  </div>
                </div>
              </Col>
              <Col sm={6}>
                <div className="ServicesBox">
                  <div className="ServicesBoxLft">
                    <Image
                      src={t("home:services.2.image_url")}
                      alt={t("home:services.2.image_alt")}
                    />
                  </div>
                  <div className="ServicesBoxRgt">
                    <h1>{t("home:services.2.heading")}</h1>
                    <p>{t("home:services.2.description")}</p>
                    <Link to="/telefonnummer">
                      {t("moreInformation")}
                      <IoIosArrowRoundForward size={27} />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="VideoScetion">
          <Container className="VideoScetionContainer">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t("home:video.heading")}</h2>
                </div>
              </Col>
            </Row>
            <Row className="align-items-center">
              <Col sm={6}>
                <div className="VideoScetionLft">
                  <ul>
                    <li>{t("home:video.list_entry_1")}</li>
                    <li>{t("home:video.list_entry_2")}</li>
                    <li>{t("home:video.list_entry_3")}</li>
                    <li>{t("home:video.list_entry_4")}</li>
                    <li>{t("home:video.list_entry_5")}</li>
                    <li>{t("home:video.list_entry_6")}</li>
                  </ul>
                  <StateButton
                    text={t("home:video.button")}
                    to="/register"
                    userTo="/LetStarted"
                  />
                </div>
              </Col>
              <Col sm={6} className="right-player-box">
                <Link to={"#"} onClick={(e) => {e.preventDefault();videoModalFunc( "explanation_video_url", t("home:video.explanation_video_url"))}}>
                  <Image
                    style={{ cursor: "pointer" }}
                    src={t("home:video.image_url")}
                    alt={t("home:video.image_alt")}
                    fluid
                  />
                  <img 
                    style={{
                      top: "10px",
                      left: "10px",
                      position: "absolute",
                      display: "block",
                      width: "40px",
                      height: "40px"
                    }}
                    alt="AI Generated Content"
                    src={"/AI.png"}
                  />
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
        <div id="FAQ" className="AppScetion">
          <Container>
            <Row>
                <Col sm={12}>
                  <h2 className="mb-4">{t("home:faq.title")}</h2>
                </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <FAQ />
              </Col>
            </Row>
          </Container>
        </div>
        <div className="ClientScetion">
          <Container className="VideoScetionContainer">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t("home:clients.heading")}</h2>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-md-center">
              <Col sm={8}>
                <Carousel data-bs-theme="dark">
                  {testimonialDetails?.map((item, index) => {
                    return (
                      <Carousel.Item key={index}>
                        <h1>{item?.name}</h1>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item?.description,
                          }}
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="AppScetion">
          <Container className="VideoScetionContainer">
            <Row className="align-items-center">
              <Col sm={6}>
                <Image
                  src={"/images/cleverdomizil-app-virtuelles-buero-iphone.webp"}
                  alt={t("home:app.image_alt")}
                  fluid
                />
              </Col>
              <Col sm={6}>
                <div className="AppScetionTxt">
                  <div>
                    <h2>{t("home:app.heading")}</h2>
                    <p>{t("home:app.description")}</p>
                  </div>
                  <div className="ImgGrp">
                    <span className="ImgGrpImg">
                      
                      <Link to={"https://play.google.com/store/apps/details?id=com.cleverdomizilmail"}>
                        <Image
                          src={"/images/cleverdomizil-google-play-virtuelles-buero-app.svg"}
                          alt={t("home:app.image_alt_google")}
                        />
                      </Link>
                    </span>
                    <span className="ImgGrpImg">
                      <Link to={"https://apps.apple.com/in/app/cleverdomicile/id6502281781"}>
                        <Image
                          src={"/images/cleverdomizil-appstore-virtuelles-buero-app.svg"}
                          alt={t("home:app.image_alt_apple")}
                        />
                      </Link>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="NetworkScetion">
          <Container className="VideoScetionContainer">
            <Row>
              <Col sm={12}>
                <div className="ScetionTitel">
                  <h2>{t("home:network.heading")}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <div className="NetworkBox">
                  <Tabs
                    defaultActiveKey="home"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                  >
                    <Tab
                      eventKey="home"
                      title={t("home:network.tab_1")}
                    >
                      <div className="NetworkList">
                        <ul>
                          {mailCountries?.map((item, index) => {
                            let countryCode = item[0]?.country?.shortname?.toLowerCase();
                            return (
                              <li key={index}>
                                <Link
                                  to={"/preise/geschaeftsadresse/"+ item[0]?.country?.id}
                                  state={{
                                    from: item[0]?.country?.name,
                                    id: item[0]?.country?.id,
                                    countryIndex: index,
                                    type: "mail"
                                  }}
                                >
                                  {countryCode === "de" ? (
                                    <Image src="/images/flags/flag-of-germany.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ch" ? (
                                    <Image src="/images/flags/flag_of_switzerland.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ch" ? (
                                    <Image src="/images/flags/flag_of_united_arab_emirates.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "en" ? (
                                    <Image src="/images/flags/flag-of-usa.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "es" ? (
                                    <Image src="/images/flags/flag_of_spain.png" width={32} height={32} alt="" />
                                  ) : countryCode === "fa" ? (
                                    <Image src="/images/flags/flag_of_iran.png" width={32} height={32} alt="" />
                                  ) : countryCode === "fr" ? (
                                    <Image src="/images/flags/flag_of_france.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "pt" ? (
                                    <Image src="/images/flags/flag_of_portugal.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ru" ? (
                                    <Image src="/images/flags/flag_of_russia.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "tr" ? (
                                    <Image src="/images/flags/flag_of_turkey.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "zh" ? (
                                    <Image src="/images/flags/flag_of_china.png" width={32} height={32} alt=""/>
                                  ) : (
                                    ""
                                  )}
                                  {" "}
                                  {item[0]?.country?.name}
                                </Link>
                              </li>
                            );
                          })}
                          <li>
                            <Link to="/Dubai">
                              <Image src="/images/flags/flag_of_united_arab_emirates.png" width={32} height={32} alt=""/>{" "}
                              Dubai
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </Tab>
                    <Tab
                      eventKey="profile"
                      title={t("home:network.tab_2")}
                    >
                      <div className="NetworkList">
                        <ul>
                          {phoneCountries?.map((item, index) => {
                            let countryCode = item?.shortname?.toLowerCase();
                            return (
                              <li key={index}>
                                <Link
                                  to={"/preise/telefonnummer/"+ item?.phone_countries_id}
                                  state={{
                                    from: item?.name,
                                    id: item?.id,
                                    countryIndex: index,
                                    type: "phone"
                                  }}
                                >
                                  {countryCode === "de" ? (
                                    <Image src="/images/flags/flag-of-germany.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ch" ? (
                                    <Image src="/images/flags/flag_of_switzerland.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ch" ? (
                                    <Image src="/images/flags/flag_of_united_arab_emirates.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "en" ? (
                                    <Image src="/images/flags/flag-of-usa.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "es" ? (
                                    <Image src="/images/flags/flag_of_spain.png" width={32} height={32} alt="" />
                                  ) : countryCode === "fa" ? (
                                    <Image src="/images/flags/flag_of_iran.png" width={32} height={32} alt="" />
                                  ) : countryCode === "fr" ? (
                                    <Image src="/images/flags/flag_of_france.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "pt" ? (
                                    <Image src="/images/flags/flag_of_portugal.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "ru" ? (
                                    <Image src="/images/flags/flag_of_russia.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "tr" ? (
                                    <Image src="/images/flags/flag_of_turkey.png" width={32} height={32} alt=""/>
                                  ) : countryCode === "zh" ? (
                                    <Image src="/images/flags/flag_of_china.png" width={32} height={32} alt=""/>
                                  ) : (
                                    ""
                                  )}
                                  {" "}
                                  {item?.name}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </Tab>
                  </Tabs>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Modal
          show={showVideoModal}
          onHide={handleVideoModalClose}
          backdrop="static"
          keyboard={false}
          size="xl" 
          centered
          className="CustomModal video-modal"
        >
          <Modal.Header closeButton />
          <Modal.Body>
            {videoUrl === undefined ? (
              <Skeleton variant="rectangular" width={665} height={375} />
            ) : (
              // <Skeleton variant="rectangular" width={665} height={375} />
              <VideoPlayer
                videoUrl={
                  videoUrl === "banner_video_url"
                    ? bannerVideolink
                    : videoUrl === "explanation_video_url"
                    ? bannerVideolink
                    : null
                }
                style={{ width: "100%", height: "400px" }}
              />
            )}
          </Modal.Body>
          <Modal.Footer/>
        </Modal>
      </div>
    </>
  );
};

export default Home;
